export const environment = {
  production: false,
  api: 'https://dev-leads.grupotopdigital.es/api',
};
